module.exports = __webpack_public_path__ + "img/info.00e7eed9.svg";